import { hexToOklch, oklchToHex } from './oklch'

const L_MIN = 0.43
const L_MAX = 0.77
const STEP = 0.09

/** Wave-3 §4 (D5, shared-base amendment): same hue per base, stepped OKLCH lightness per
 *  value type. Steps go DARKER first (white surface — darker keeps label contrast); when the
 *  base sits too low to fit the whole ladder, steps go lighter instead. Hue/chroma are kept;
 *  oklchToHex gamut-clamps chroma when needed.
 *  Wave-4 #7a: when the full ladder fits on NEITHER side (realistic trigger: count ≥ 5), the
 *  original fixed STEP would clamp several trailing indices onto the SAME lightness (a visible
 *  collision). Guard: shrink the step to fit the roomier side instead. Fitting cases (either
 *  side has room for the full span) are untouched — byte-identical to wave-3. */
export function stepLightness(hex: string, index: number, count: number): string {
  if (index === 0 || count < 2) return hex
  const { l, c, h } = hexToOklch(hex)
  const span = STEP * (count - 1)
  let dir: 1 | -1
  let step: number
  if (l - span >= L_MIN) {
    dir = -1
    step = STEP
  } else if (l + span <= L_MAX) {
    dir = 1
    step = STEP
  } else {
    const roomDown = l - L_MIN
    const roomUp = L_MAX - l
    dir = roomDown >= roomUp ? -1 : 1
    step = Math.max(roomDown, roomUp) / (count - 1)
  }
  const l2 = Math.min(L_MAX, Math.max(L_MIN, l + dir * step * index))
  return oklchToHex(l2, c, h)
}
